<template>
    <div class="md-invalid standard" :style="{ paddingTop, marginBottom }">
        <div class="img-box">
            <img
                src="//static.chimeroi.com/site/images/template/house-ops-v3.png"
                alt
            />
        </div>
        <div class="text-box">
            <p>{{ $t('md-invalid.theHouseIsNoLonger') }}</p>
        </div>
    </div>
</template>

<script>
import common from '../index';
export default {
    mixins: [common]
};
</script>
<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';
.md-invalid.standard {
    .img-box {
        text-align: center;
        img {
            max-width: 368px;
            width: 100%;
            height: 177px;
            // margin-top: 100px;
        }
    }
    .text-box {
        text-align: center;
        p {
            color: #202437;
            font-family: var(--font-normal);
            font-size: 24px;
            font-weight: bold;
            margin-top: 60px;
        }
        a {
            display: inline-block;
            height: 40px;
            line-height: 40px;
            width: 168px;
            @include color-theme('background-color');
            color: #fff;
            font-size: 16px;
            margin-top: 30px;
        }
    }
    @include media-800 {
        .text-box {
            p {
                margin: 60px 0 0;
            }
        }
    }
    @include media-600 {
        .img-box {
            img {
                margin-top: 50px;
            }
        }
        .text-box {
            p {
                margin: 40px 0 0;
                font-size: 16px;
            }
            a {
                font-size: 14px;
                height: 35px;
                line-height: 35px;
                width: 146px;
                margin-top: 15px;
            }
        }
    }
    @include media-375 {
        .img-box {
            img {
                max-width: 240px;
                height: 115px;
            }
        }
        .text-box {
            p {
                margin: 30px 0 0;
                font-size: 14px;
                font-weight: bold;
                line-height: 1.5;
                letter-spacing: normal;
                color: #202437;
            }
        }
    }
}
</style>
